import React, { useState, useEffect } from 'react';

const CountdownTimer = ({ endTime, targetTime, mode = 'end', extendedTime, isPaused }) => {
  const [timeLeft, setTimeLeft] = useState('');
  const [isUrgent, setIsUrgent] = useState(false);

  useEffect(() => {
    const calculateTime = () => {
      const target = new Date(extendedTime || endTime || targetTime);
      const now = new Date();
      const diff = target - now;

      if (diff <= 0) {
        setTimeLeft('00:00:00');
        return;
      }

      const hours = Math.floor(diff / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const days = Math.floor(hours / 24);
      const remainingHours = hours % 24;

      if (days > 0) {
        setTimeLeft(`${days}d ${remainingHours}h ${minutes}m`);
      } else {
        setTimeLeft(
          `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
        );
      }

      // Urgent if less than 24 hours
      setIsUrgent(diff < 24 * 60 * 60 * 1000);
    };

    calculateTime();
    if (!isPaused) {
      const timer = setInterval(calculateTime, 1000);
      return () => clearInterval(timer);
    }
  }, [endTime, targetTime, extendedTime, isPaused]);

  return (
    <span className={`font-mono ${isUrgent && !isPaused ? 'text-red-600 font-bold' : ''}`}>
      {isPaused ? 'PAUSED' : timeLeft}
    </span>
  );
};

export default CountdownTimer;
